import { render, staticRenderFns } from "./customtextarea.vue?vue&type=template&id=1729beda&scoped=true&"
import script from "./customtextarea.vue?vue&type=script&lang=js&"
export * from "./customtextarea.vue?vue&type=script&lang=js&"
import style0 from "./customtextarea.vue?vue&type=style&index=0&id=1729beda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1729beda",
  null
  
)

export default component.exports